export class POLineItem {
    PurchaseOrderNumber: number;
    PurchaseOrderLineNumber: number;
    EquipmentID: number;
}
